import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import MenuFarolDeskMobile from "../../../components/gestao/MenuFarol/MenuDeskMobile";
import { defaultRequest } from "../../../utils/functions";
import "react-datepicker/dist/react-datepicker.css";
import "../Acessos/acessos.css";
import "./atualizacoes.css";
import Row from "./RowAtualizacoes";
import { rotuloColuna } from "./statusAtualizacao";

/**
 * Tela "Log > Atualizações".
 *
 * Mostra, em uma matriz marca x etapa (catálogo, SKUs, atributos, API, gestão,
 * estúdio, estoque CD, marketplace), o horário da última gravação de cada cache
 * no Redis — é o painel usado para saber se os ETLs rodaram no dia.
 *
 * As células são coloridas pelo status (hoje / ontem / dois dias ou mais / sem
 * dado) e trazem o tempo decorrido, para que o atraso salte aos olhos sem
 * precisar comparar datas manualmente.
 */
export default function Atualizacoes() {
    const route = "/atualizacoes";

    const [dados, setDados] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState("");
    const [consultadoEm, setConsultadoEm] = useState(null);

    const buscar = useCallback(async () => {
        setCarregando(true);
        setErro("");

        try {
            const response = await defaultRequest(route, {});
            setDados(Array.isArray(response) ? response : []);
            setConsultadoEm(new Date());
        } catch (error) {
            console.log("Error:", error.message);
            setErro("Não foi possível carregar as atualizações.");
        } finally {
            setCarregando(false);
        }
    }, []);

    useEffect(() => {
        buscar();
    }, [buscar]);

    // Colunas vêm do próprio payload (a API pode ganhar novas etapas sem que a
    // tela precise mudar); o rótulo amigável é resolvido em statusAtualizacao.
    const colunas = dados.length ? Object.keys(dados[0]) : [];

    return (
        <MenuFarolDeskMobile
            title={""}
            body={
                <div className="card-total">
                    <div className="atualizacoes-header">
                        <div>
                            <h2 className="atualizacoes-titulo">LOG DE ATUALIZAÇÕES</h2>
                            <p className="atualizacoes-subtitulo">
                                Última atualização de cada cache por marca
                                {consultadoEm &&
                                    ` · consultado às ${consultadoEm.toLocaleTimeString("pt-BR")}`}
                            </p>
                        </div>
                    </div>

                    <div className="divider-pacote" />

                    {erro && <div className="atualizacoes-vazio">{erro}</div>}

                    {!erro && carregando && !dados.length && (
                        <div className="atualizacoes-vazio">Carregando atualizações...</div>
                    )}

                    {!erro && !!dados.length && (
                        <Grid container>
                            <div className="atualizacoes-tabela-wrapper">
                                <table className="atualizacoes-tabela">
                                    <thead>
                                        <tr className="header-tabela">
                                            {colunas.map((coluna) => (
                                                <th
                                                    key={coluna}
                                                    className={`th ${coluna === "MARCA" ? "col-marca" : ""}`}
                                                >
                                                    {rotuloColuna(coluna)}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dados.map((linha) => (
                                            <Row key={linha.MARCA} row={linha} />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                    )}
                </div>
            }
        />
    );
}
